// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"409":"3ab679c6","453":"518a49af","586":"bbca7f2f"}[chunkId] + ".chunk.js";
};